import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Home from './pages/Home';
import Features from './pages/Features';
import Solutions from './pages/Solutions';
import Pricing from './pages/Pricing';
import Membership from './pages/Membership';
import PaymentSuccess from './pages/PaymentSuccess';
import Resources from './pages/Resources';
import PostDetails from './pages/PostDetails';
import Contact from './pages/Contact';
import About from './pages/About';
import Login from './pages/Auth/Login';
import Register from './pages/Auth/Register';
import ForgotPassword from './pages/Auth/ForgotPassword';
import ResetPassword from './pages/Auth/ResetPassword';
import VerifyEmail from './pages/Auth/VerifyEmail';
import Dashboard from './pages/Dashboard';
import Profiles from './pages/Profiles';
import CreateProfile from './pages/Profiles/CreateProfile';
import Profile from './pages/Profile';
import Teachers from './pages/Teachers';
import TeacherDetail from './pages/Teachers/TeacherDetail';
import CreateTeacher from './pages/Teachers/CreateTeacher';
import Chat from './pages/Chat';
import ChatProperties from './pages/Chat/ChatProperties';
import RealtimeSession from './pages/Chat/RealtimeSession';
import LearningSessionDetails from './pages/LearningSession/LearningSessionDetails';
import Account from './pages/Account';
import AdminDashboard from './pages/Admin/AdminDashboard';
import ParentDashboard from './pages/Parent/ParentDashboard';
import ProtectedRoute from './components/ProtectedRoute';
import { HelmetProvider } from 'react-helmet-async';
import { AuthProvider } from './contexts/AuthContext';

function App() {
  return (
    <HelmetProvider>
      <AuthProvider>
        <Router>
          <Routes>
            {/* Public Routes */}
            <Route path="/" element={<Home />} />
            <Route path="/features" element={<Features />} />
            <Route path="/solutions" element={<Solutions />} />
            <Route path="/pricing" element={<Pricing />} />
            <Route path="/membership" element={<Membership />} />
            <Route path="/payment-success" element={<PaymentSuccess />} />
            <Route path="/resources" element={<Resources />} />
            <Route path="/resources/post/:id" element={<PostDetails />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/about" element={<About />} />
            
            {/* Auth Routes */}
            <Route path="/auth/login" element={<Login />} />
            <Route path="/auth/register" element={<Register />} />
            <Route path="/auth/forgot-password" element={<ForgotPassword />} />
            <Route path="/auth/reset-password" element={<ResetPassword />} />
            <Route path="/auth/verify-email" element={<VerifyEmail />} />
            
            {/* Protected Routes */}
            <Route 
              path="/dashboard" 
              element={
                <ProtectedRoute>
                  <Dashboard />
                </ProtectedRoute>
              } 
            />
            <Route 
              path="/profiles" 
              element={
                <ProtectedRoute>
                  <Profiles />
                </ProtectedRoute>
              } 
            />
            <Route 
              path="/create-profile" 
              element={
                <ProtectedRoute>
                  <CreateProfile />
                </ProtectedRoute>
              } 
            />
            <Route 
              path="/profile/:profileId" 
              element={
                <ProtectedRoute>
                  <Profiles />
                </ProtectedRoute>
              } 
            />
            <Route 
              path="/teachers" 
              element={
                <ProtectedRoute>
                  <Teachers />
                </ProtectedRoute>
              } 
            />
            <Route 
              path="/teachers/new" 
              element={
                <ProtectedRoute>
                  <CreateTeacher />
                </ProtectedRoute>
              } 
            />
            <Route 
              path="/teacher/:teacherId" 
              element={
                <ProtectedRoute>
                  <TeacherDetail />
                </ProtectedRoute>
              } 
            />
            <Route 
              path="/chat/:profileId" 
              element={
                <ProtectedRoute>
                  <Chat />
                </ProtectedRoute>
              } 
            />
            <Route 
              path="/chat/:profileId/properties" 
              element={
                <ProtectedRoute>
                  <ChatProperties />
                </ProtectedRoute>
              } 
            />
            <Route 
              path="/chat/:profileId/realtime" 
              element={
                <ProtectedRoute>
                  <RealtimeSession />
                </ProtectedRoute>
              } 
            />
            <Route 
              path="/session/:profileId" 
              element={
                <ProtectedRoute>
                  <RealtimeSession />
                </ProtectedRoute>
              } 
            />
            <Route 
              path="/learning-session/:profileId" 
              element={
                <ProtectedRoute>
                  <LearningSessionDetails />
                </ProtectedRoute>
              } 
            />
            <Route 
              path="/account" 
              element={
                <ProtectedRoute>
                  <Account />
                </ProtectedRoute>
              } 
            />
            <Route 
              path="/profile" 
              element={
                <ProtectedRoute>
                  <Profile />
                </ProtectedRoute>
              } 
            />
            <Route 
              path="/parent/dashboard" 
              element={
                <ProtectedRoute>
                  <ParentDashboard />
                </ProtectedRoute>
              } 
            />
            <Route 
              path="/admin" 
              element={
                <ProtectedRoute requireAdmin={true}>
                  <AdminDashboard />
                </ProtectedRoute>
              } 
            />
          </Routes>
        </Router>
      </AuthProvider>
    </HelmetProvider>
  );
}

export default App;